import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  persentase_perubahan_revenue: {
    revenue_this_month: 0,
    persentase: "0%",
  },
  persentase_perubahan_order: {
    order_this_month: 0,
    persentase: "0%",
  },
  persentase_cash_flow: {
    income: [],
    expense: [],
  },
  top_selling: [],
  recent_transaction: [],
  sales_order: {
    penjualan: [],
    pembelian: [],
  },
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      state.persentase_perubahan_revenue =
        action.payload.persentase_perubahan_revenue;
      state.persentase_perubahan_order =
        action.payload.persentase_perubahan_order;
      state.persentase_cash_flow = action.payload.persentase_cash_flow;
      state.top_selling = action.payload.top_selling;
      state.recent_transaction = action.payload.recent_transaction;
      state.sales_order = action.payload.sales_order;
    },
  },
});

export const { setDashboardData } = dashboardSlice.actions;

export default dashboardSlice.reducer;
